// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__11v3c","unreadBadge":"styles_unreadBadge__2J7eN","modalContent":"styles_modalContent__3slwf","modal":"styles_modal__EMhOR"};